// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"close-button_Wrapper__dlc_F","Light":"close-button_Light__eJh2w","Icon":"close-button_Icon__0T9Dk","Dark":"close-button_Dark__X5l_h"};